import request from "@/utils/request";

// 成长中心-明细
export const  developDetail =(query) =>{
    return request({
        url: "/businessservice/appHome/develop/detail",
        method:"get",
        params: query
    })
}

// 师资培训(0-直播1-录播2-线下)
export const  developTrain =(query) =>{
    return request({
        url: "/businessservice/appHome/develop/train",
        method:"get",
        params: query
    })
}
// 教学教研(0-个人备课1-协同备课2-听评课)
export const  developStudy =(query) =>{
    return request({
        url: "/businessservice/appHome/develop/syudy",
        method:"get",
        params: query
    })
}

// 教科研(0-课题1-赛事2-活动)
export const  developEdu =(query) =>{
    return request({
        url: "/businessservice/appHome/develop/activity",
        method:"get",
        params: query
    })
}
